  (function () {
    if (window.aceiiSecurityContactAnchorInit) return;
    window.aceiiSecurityContactAnchorInit = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('a[href="#aceii-security-contact"]');
      if (!trigger) return;

      var target = document.getElementById('aceii-security-contact');
      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#aceii-security-contact');
      }
    }, true);
  })();
